import { Phone, CheckCircle } from 'lucide-react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '../../components/ui/accordion';
import '../ServicePage.css';

const OrthopaedicService = () => {
  const whatsappUrl = 'https://wa.me/919886332528';

  const conditions = [
    'Arthritis and joint pain',
    'Fractures and post-fracture rehabilitation',
    'Ligament and tendon injuries',
    'Muscle strains and sprains',
    'Joint replacement rehabilitation',
    'Osteoporosis management',
    'Chronic pain conditions',
    'Sports-related orthopedic injuries'
  ];

  const equipment = ['TENS/IFT therapy', 'Ultrasound therapy', 'Laser therapy', 'Exercise rehabilitation equipment', 'Manual therapy techniques'];

  return (
    <div className="service-page">
      <div className="service-hero">
        <div className="container">
          <h1>Orthopaedic Physiotherapy</h1>
          <p className="service-subtitle">Specialized treatment for bone, joint, muscle, and ligament conditions</p>
        </div>
      </div>

      <section className="section">
        <div className="container service-container">
          <div className="service-content">
            <h2>What is Orthopaedic Physiotherapy?</h2>
            <p>Orthopaedic physiotherapy focuses on the treatment of musculoskeletal conditions affecting bones, joints, muscles, ligaments, and tendons. Our specialized physiotherapists use evidence-based techniques to reduce pain, improve mobility, and restore function.</p>

            <h2>Conditions We Treat</h2>
            <ul className="conditions-list">
              {conditions.map((condition, index) => (
                <li key={index}>
                  <CheckCircle size={20} />
                  <span>{condition}</span>
                </li>
              ))}
            </ul>

            <h2>What to Expect at Our Clinic</h2>
            <p>During your first visit, our certified physiotherapist will conduct a thorough assessment of your condition, including movement analysis and pain evaluation. Based on this assessment, we'll create a personalized treatment plan that may include manual therapy, therapeutic exercises, and advanced equipment-based treatments.</p>

            <h2>Equipment Used</h2>
            <div className="equipment-tags">
              {equipment.map((item, index) => (
                <span key={index} className="equipment-tag">{item}</span>
              ))}
            </div>

            <div className="service-cta">
              <a href={whatsappUrl} target="_blank" rel="noopener noreferrer" className="btn-primary">
                <Phone size={20} />
                Book Appointment on WhatsApp
              </a>
            </div>

            <h2>Frequently Asked Questions</h2>
            <Accordion type="single" collapsible className="service-faq">
              <AccordionItem value="item-1">
                <AccordionTrigger>How long does orthopaedic physiotherapy take?</AccordionTrigger>
                <AccordionContent>
                  Treatment duration varies depending on your condition. Acute injuries may require 4-6 weeks, while chronic conditions might need 8-12 weeks or more. Your physiotherapist will provide a personalized timeline.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-2">
                <AccordionTrigger>Is physiotherapy painful?</AccordionTrigger>
                <AccordionContent>
                  While some discomfort may occur during treatment, especially when working on stiff or injured areas, we ensure the therapy is tolerable. Any pain should be manageable and should decrease as you progress.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-3">
                <AccordionTrigger>Can I avoid surgery with physiotherapy?</AccordionTrigger>
                <AccordionContent>
                  In many cases, physiotherapy can help avoid surgery by effectively managing pain and restoring function. However, this depends on your specific condition and severity. We work closely with orthopedic surgeons when needed.
                </AccordionContent>
              </AccordionItem>
              <AccordionItem value="item-4">
                <AccordionTrigger>Do I need a doctor's referral?</AccordionTrigger>
                <AccordionContent>
                  No, you can directly book an appointment with us. However, if you have medical reports or a doctor's referral, please bring them along as they help us understand your condition better.
                </AccordionContent>
              </AccordionItem>
            </Accordion>
          </div>
        </div>
      </section>
    </div>
  );
};

export default OrthopaedicService;